<template>
   <section class="config-group search-box" aria-label="Search Box">
      <div class="row">
         <div class="column">
            <h3>{{texts.global.basicSettings}}</h3>
            <Checkmark :label="texts.searchBox.showIcon" checkbox-id="show-icon--i" :value="isIconShown" @input="toggleIcon" style="margin:0.5em 0;"/>
            <ExpandableColorPicker type="inline"  v-if="isIconShown" :title="texts.searchBox.iconColor" :value="config.style.searchBox.icon.color" :onChange="onIconColorChange"/>
            <Checkmark :label="texts.searchBox.showButton" @input="toggleButton" :value="isButtonShown" checkbox-id="show-button--i" style="margin:0.5em 0;"/>
            <RadioGroup v-if="isButtonShown" :items="buttonRadioGroups" name="button-type" @input="onButtonTypeChange" class="align-right"/>
            <div v-if="isButtonShown && config.style.searchBox.button.icon===undefined" class="align-right">
              <input type="text" v-model="config.style.searchBox.button.text" style="width: 100px;"/>
            </div>
            <div class="row stretch" style="margin: 0.5em 0;" :style="{marginTop: isButtonShown && config.style.searchBox.button.icon===undefined ? '1em' : '0.5em'}">
              <label for="sb-placeholder--i">{{texts.searchBox.placeholder}}</label>
              <input id="sb-placeholder--i" class="expandable" type="text" v-model="config.searchBox.placeholder" :placeholder="texts.searchBox.search" style="width: 140px;"/>
            </div>
            <ExpandableColorPicker type="inline" v-if="isButtonShown && config.style.searchBox.button.icon!==undefined" :title="texts.searchBox.buttonIconColor" :value="config.style.searchBox.button.color" :onChange="onButtonColorChange"/>
         </div>
         <div class="column">
            <h3>{{texts.global.style}}</h3>
            <ExpandableColorPicker type="inline" :title="texts.global.backgroundColor" :value="config.style.searchBox.background ? config.style.searchBox.background.color : '#ffffff'" :onChange="onBackgroundColorChange"/>
            <div class="row stretch" style="margin: 0.5em 0;">
              <label for="sb-padding--i">{{texts.global.padding}}</label>
              <input id="sb-padding--i" type="number" min="0" max="20" :value="config.style.searchBox.padding ? config.style.searchBox.padding.replace('px',''):0" @change="onPaddingChange"/>
            </div>
            <div v-if="isButtonShown && config.style.searchBox.button.icon!==undefined" class="row stretch" style="margin: 0.5em 0;">
              <label for="sbuticon-padding--i">{{texts.searchBox.buttonIconPadding}}</label>
              <input id="sbuticon-padding--i" type="number" min="0" max="20" :value="config.style.searchBox.button.iconPadding ? config.style.searchBox.button.iconPadding.replace('px',''):(config.style.searchBox.padding ? config.style.searchBox.padding.replace('px',''):0)" @change="onButtonIconPaddingChange"/>
            </div>
            <div class="row stretch"  style="margin: 0.5em 0;">
              <label for="sb-font-size--i">{{texts.searchBox.textSize}}</label>
              <input id="sb-font-size--i" type="number" min="8" max="40" :value="config.style.searchBox.text.size.replace('px','')" @change="onTextSizeChange"/>
            </div>
            <ExpandableColorPicker type="inline" :title="texts.global.textColor" :value="config.style.searchBox.text.color" :onChange="onTextColorChange"/>
            <div class="row stretch"  style="margin: 0.5em 0;">
              <label for="sb-border-radius--i">{{texts.global.borderRadius}}</label>
              <input id="sb-border-radius--i" type="number" min="0" max="20" :value="config.style.searchBox.border.radius.replace('px','')" @change="onBorderRadiusChange"/>
            </div>
            <ExpandableColorPicker type="inline" :title="texts.global.borderColor" :value="config.style.searchBox.border.color" :onChange="onBorderColorChange"/>
         </div>
         <div class="column">
            <h3>{{texts.searchBox.voiceSearch}}</h3>
            <Checkmark label="Enabled" v-model="config.voiceSearch.enabled" checkbox-id="use-voicesearch--i" style="margin:0.5em 0;"/>
               <div class="row stretch" v-if="config.voiceSearch.enabled">
                <label>{{texts.searchBox.language}}</label>
                <select v-model="config.voiceSearch.lang" >
                    <option v-for="lang in langs" :key="lang.tag" :value="lang.tag">{{lang.name}}</option>
                </select>
            </div>
            <ExpandableColorPicker v-if="config.voiceSearch.enabled" type="inline" :title="texts.searchBox.microphoneColor" :value="config.voiceSearch.color" :onChange="onMicrophoneColorChange"/>
         </div>
      </div>
   </section>
</template>

<script>
import Vue from "vue";
import Checkmark from "../Checkmark";
import RadioGroup from "../RadioGroup";
import ExpandableColorPicker from "../ExpandableColorPicker";
import Languages from '../../assets/SupportedLanguages';

export default {
  name: "SearchBox",
  components: {
    Checkmark,
    RadioGroup,
    ExpandableColorPicker
  },
  data(){return {langs: Languages}},
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    isIconShown() {
      const config = this.config;
      return config.style &&
        config.style.searchBox &&
        config.style.searchBox.icon &&
        config.style.searchBox.icon.image
        ? true
        : false;
    },
    isButtonShown() {
      const config = this.config;
      return config.style &&
        config.style.searchBox &&
        config.style.searchBox.button
        ? true
        : false;
    },
    isButtonIcon() {
      const config = this.config;
      return config.style.searchBox.button.icon !== undefined;
    },
    isUsingSpecialMobileSuggestions() {
      return this.config.searchBox;
    },
    buttonRadioGroups() {
      return [
        {
          id: "icon--rb",
          isActive: this.isButtonIcon,
          label: "Icon",
          value: "icon"
        },
        {
          id: "text--rb",
          isActive: !this.isButtonIcon,
          label: "Text",
          value: "text"
        }
      ];
    }
  },
  methods: {
    ensureConfig() {
      const config = this.config;
      if (config.style === undefined) {
        Vue.set(config, "style", {});
      }
      if (config.style.searchBox === undefined) {
        Vue.set(config.style, "searchBox", {});
      }
      if (config.searchBox === undefined) {
        Vue.set(config, "searchBox", { placeholder: "" });
      }
      if (config.style.searchBox.text === undefined) {
        Vue.set(config.style.searchBox, "text", {
          color: "#333333",
          size: "14px"
        });
      }
      if (config.style.searchBox.border === undefined) {
        Vue.set(config.style.searchBox, "border", {
          color: "#dddddd",
          radius: "0px"
        });
      }
    },
    toggleIcon(checked) {
      this.ensureConfig();
      const config = this.config;
      if (checked) {
        Vue.set(config.style.searchBox, "icon", {
          image: "magnifier",
          color: "#666666"
        });
      } else {
        Vue.delete(config.style.searchBox, "icon");
      }
    },
    onIconColorChange(color) {
      Vue.set(this.config.style.searchBox.icon, "color", color.hex);
    },
    toggleButton(checked) {
      this.ensureConfig();
      const config = this.config;
      if (checked) {
        Vue.set(config.style.searchBox, "button", {
          text: " ",
          icon: "magnifier",
          color: "#ffffff",
		  iconPadding: '8px',
		  backgroundColor: config.style.accentColor
        });
        Vue.set(config.searchBox, "searchButton", "#searchButton");
      } else {
        Vue.delete(config.style.searchBox, "button");
        Vue.delete(config.searchBox, "searchButton");
      }
    },
    onButtonTypeChange(type) {
      const config = this.config;
      const isIcon = type == "icon";
      const text = isIcon ? " " : "Search";
      const icon = isIcon ? "magnifier" : undefined;
      Vue.set(config.style.searchBox.button, "text", text);
      Vue.set(config.style.searchBox.button, "icon", icon);
    },
    onButtonColorChange(color) {
      Vue.set(this.config.style.searchBox.button, "color", color.hex);
    },
    onTextColorChange(color) {
      Vue.set(this.config.style.searchBox.text, "color", color.hex);
    },
    onMicrophoneColorChange(color) {
      Vue.set(this.config.voiceSearch, "color", color.hex);
    },
    onBackgroundColorChange(color) {
      if (this.config.style.searchBox.background === undefined) {
        Vue.set(this.config.style.searchBox, "background", {
          color: "#ffffff"
        });
      }
      Vue.set(this.config.style.searchBox.background, "color", color.hex);
    },
    onPaddingChange(e) {
      Vue.set(this.config.style.searchBox, "padding", e.target.value + "px");
    },
    onButtonIconPaddingChange(e) {
      Vue.set(this.config.style.searchBox.button, "iconPadding", e.target.value + "px");
    },
    onTextSizeChange(e) {
      Vue.set(this.config.style.searchBox.text, "size", e.target.value + "px");
    },
    onBorderColorChange(color) {
      Vue.set(this.config.style.searchBox.border, "color", color.hex);
    },
    onBorderRadiusChange(e) {
      Vue.set(
        this.config.style.searchBox.border,
        "radius",
        e.target.value + "px"
      );
    }
  },
  mounted() {
    this.ensureConfig();
  }
};
</script>

<style>
#app .align-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end !important;
  width: 100%;
}

input.expandable {
  transition: width 0.3s ease-in-out;
}

input.expandable:focus {
  width: 50% !important;
}

.config-group.search-box select {
    width: 100%;
    max-width: 225px;
    margin: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/configuration/SearchBox.vue